import FormDatePicker from '../templates/FormDatePicker';
import { FormItemProps } from '../templates/FormProps';

const ExpiredDate = ({
  name = 'expired_at',
  label = 'Expired Date',
  placeholder = 'Enter Expired Date',
  rules,
  ...props
}: FormItemProps): JSX.Element => {
  return <FormDatePicker {...{ name, label, placeholder }} {...(rules && { rules })} {...props} />;
};

export default ExpiredDate;
